import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------

export default function FormProviderComponent({ children, onSubmit, methods }) {
  return (
    <Form {...methods}>
        <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}